<template>
  <!-- <VuePullRefresh :on-refresh="onRefresh"> -->
  <div class="indexview" :class="loginIfon ? 'indexblock' : ''">
    <!-- 没有订单空状态star -->
    <div class="noorder" v-if="!online">
      <img src="../../static/image/noorder.png" alt class="noorderimg" />

      <div class="endtext endtish font32">
        <span class="mr10">请点击右下角</span>
        <img
          src="../../static/image/order-star.png"
          alt
          class="starorsersmall"
        />
        <span class="ml10">后可进行接单</span>
      </div>
    </div>
    <div class="noorder" v-if="online && orderInfo.length <= 0">
      <img src="../../static/image/noorder.png" alt class="noorderimg" />
      <div class="endtext font32">目前没有订单</div>
    </div>
    <!-- 没有订单空状态end -->

    <!-- 有订单状态star -->
    <Orderlist
      v-else
      :orderInfo="orderInfo"
      :total="total"
      :formData="formData"
    ></Orderlist>
    <!-- 有订单状态end -->

    <!-- 开始接单按钮star -->
    <img
      v-if="online"
      src="../../static/image/refresh.png"
      alt
      class="starorderbtn refreshbtn"
      @click="refreshInfo()"
    />

    <img
      :src="online ? work : work_on"
      alt
      class="starorderbtn"
      @click="switchwork"
    />
    <!-- 开始接单按钮end -->

    <!-- tabbar 底部栏-->
    <Tabbar></Tabbar>
    <!-- tabbar 底部栏end -->
  </div>
  <!-- </VuePullRefresh> -->
</template>

<script>
import Tabbar from '../components/tabbar.vue'
import Orderlist from '../components/orderlist.vue'
import VuePullRefresh from 'vue-pull-refresh'
import router from '../router'
import { Toast } from 'vant'
export default {
  name: 'index',
  components: {
    Tabbar: Tabbar,
    Orderlist: Orderlist,
    VuePullRefresh: VuePullRefresh
  },
  data () {
    return {
      isLoading: false,
      online: '', // 员工是否在线   true在线   false下线
      orderInfo: [], // 订单数据
      hasMore: true,
      loginIfon: false,
      work: require('../../static/image/order-storp.png'),
      work_on: require('../../static/image/order-star-big.png'),
      // 列表查询参数
      formData: {
        pageNum: 1,
        pageSize: 10
      },
      total: '',
      flag: true
    }
  },

  created () {
    this.loginIfon = false
    const code = this.getCode('code')
    const token = localStorage.getItem('token')
    if (!token && code) {
      // 授权页面进入
      this.$api
        .HZrequest('/we-chat/gzh/login', 'POST', { code: code })
        .then((res) => {
          var token = res.data.token
          if (token) {
            localStorage.setItem('token', 'Bearer ' + token)
            this.getWasherOnDuty()
          }
          if (res.data.code == 302) {
            // 跳转login页面(已激活员工过期)
            router.replace({
              path: '/login'
            })
          }
        })
    } else {
      // 直接进入 先访问 token 过期后 会重定向到首页
      this.getWasherOnDuty()
    }
  },
  mounted () {},

  methods: {
    // 获取上下班状态
    getWasherOnDuty () {
      // 请求上下班状态
      this.$api
        .HZrequest('/we-chat/gzh/washer-on-duty', 'GET', null)
        .then((res) => {
          console.log(res)

          this.loginIfon = true
          if (res.data.onDuty == '0') {
            this.online = true
            this.getIndexInfo(this.formData)
          } else {
            this.online = false
          }
        })
    },

    // 接单/停止接单
    switchwork () {
      var that = this
      this.online = !this.online
      if (this.online == true) {
        this.$api
          .HZrequest(
            '/we-chat/gzh/washer-on-duty',
            'POST',
            { onDuty: '0' },
            null
          )
          .then((res) => {
            that.hasMore = true
            that.orderInfo = [] // 刷新清空原来数据
            that.getIndexInfo(that.formData)
          })
      } else {
        this.$api
          .HZrequest(
            '/we-chat/gzh/washer-on-duty',
            'POST',
            { onDuty: '1' },
            null
          )
          .then((res) => {
            that.orderInfo = []
          })
      }
    },
    getCode (name) {
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
      var r = window.location.search.substr(1).match(reg)
      if (r != null) return decodeURI(r[2])
      return null
    },

    // 请求首页数据
    getIndexInfo (formData) {
      var that = this
      that.loginIfon = true
      if (that.flag == false) {
        return
      }
      that.flag = false
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0
      })
      this.$api
        .HZrequest('/we-chat/gzh/get-new-orders', 'GET', formData)
        .then((res) => {
          if (res.rows) {
            that.total = res.total
            that.orderInfo = that.orderInfo.concat(res.rows)
          }
          setTimeout(function () {
            Toast.clear()
            that.flag = true
          }, 500)
        })
    },
    refreshInfo () {
      var that = this
      // that.hasMore = true
      that.orderInfo = [] // 刷新清空原来数据
      that.getIndexInfo(that.formData)
    }
  }
}
</script>

<style>
@import url("../../static/css/index.css");
</style>



// WEBPACK FOOTER //
// src/view/index.vue